<template>
  <DataTable
      ref="tree"
      v-model:selection="selectedAlarmPointItem"
      :dataKey="tableDataKey"
      :lazy="true"
      :page="apCurrentPage"
      :paginator="true"
      :paginatorTemplate="paginatorTemplate"
      :rowHover="true"
      :rows="alarmPointRows"
      :rowsPerPageOptions="alarmPointPageSizeOptions"
      :scrollable="true"
      :totalRecords="apTotalRecords"
      :value="alarmPoints"
      class="tight"
      style="width: 100%"
      scrollHeight="72vh"
      selectionMode="single"
      stripedRows
      @page="selectTablePage($event)"
      @row-click="selectAlarmPoint($event.data);"
  >
    <Column
        v-if="expandSidebarDialog"
        :header="_t('label_Icon')"
        :hidden="!handleCheckRow('icon')"
        :style="'padding-left: 10px!important; max-width: 55px;'"
        field="icon"
    >
      <template #body="slotProps">
        <i :class="`icon_medium p-mr-2 ${normalizeIcon(slotProps?.data.icon).name}`"
           :style="`font-size: 24px; color: white; background-color: ${normalizeIcon(slotProps?.data.icon).color};`"/>
      </template>
    </Column>

    <Column
        :header="_t('Name')"
        :style="columnStyle('name')"
        field="name"
    >
      <template #body="slotProps">
             <span v-tooltip.bottom="slotProps.field" :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                   class="wrap"
                   style="word-break: break-all;"
             >
               {{
                 selectedTab === 'ALARMID' ? slotProps.data.alarmPointId : slotProps.data.name
               }}
               {{
                 (selectedTab === 'SYSTEMID' && slotProps.data.systemId.length > 0) ? '[' + slotProps.data.alarmPointId + ']' : ''
               }}
          </span>
      </template>
    </Column>

    <Column
        v-if="expandSidebarDialog"
        :header="_t('label_alarm_id')"
        :hidden="!handleCheckRow('alarmId')"
        :style="columnStyle('alarmId')"
        field="alarmPointId"
    >
      <template #body="slotProps">
            <span
                :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                style="word-break: break-all;"
            >
              {{ slotProps.data.alarmPointId }}
            </span>

      </template>
    </Column>

    <Column
        v-if="expandSidebarDialog"
        :header="_t('label_system_id')"
        :hidden="!handleCheckRow('systemId')"
        :style="columnStyle('systemId')"
        field="systemId">
      <template #body="slotProps">
            <span
                :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                style="text-align: center; word-break: break-all;"
            >
              {{ slotProps.data.systemId }}
            </span>

      </template>
    </Column>

    <Column
        v-if="expandSidebarDialog"
        :header="_t('label_alarm_plan')"
        :hidden="!handleCheckRow('alarmPlan')"
        :style="columnStyle('alarmPlan')"
        field="alarmPointPlan"
    >
      <template #body="slotProps">
            <span
                :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                style="word-break: break-all;"
            >
              {{ slotProps.data.alarmPlanName }}
            </span>

      </template>
    </Column>

    <Column
        v-if="expandSidebarDialog"
        :header="_t('ALARM_POINT_ROTATIONAL_CAL')"
        :hidden="!handleCheckRow('schedule')"
        :style="columnStyle('schedule')"
        field="schedule"
    >
      <template #body="slotProps">
            <span
                :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                style="word-break: break-all;"
            >
              {{ slotProps.data.rotationalCalendarName }}
            </span>
      </template>
    </Column>

    <Column
        v-if="expandSidebarDialog"
        :header="_t('ALARMSTATUS')"
        :hidden="!handleCheckRow('alarmStatus')"
        :style="columnStyle('alarmStatus')"
        field="alarmPointStatus">
      <template #body="slotProps">
            <span
                :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                style="text-align: center; word-break: break-all;"
            >
              {{ slotProps.data.alarmPointStatus }}
            </span>
      </template>
    </Column>

    <Column
        v-if="expandSidebarDialog"
        :hidden="!handleCheckRow('mode')"
        :style="columnStyle('mode')"
        field="acknowledgeMode"
        header="Mode"/>
    <Column
        v-if="expandSidebarDialog"
        :header="_t('ORGANIZATION')"
        :hidden="!handleCheckRow('orgName')"
        :style="columnStyle('orgName')"
        field="orgName"
    >
      <template #body="slotProps">
            <span
                :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                style="word-break: break-all;"
            >
              {{ slotProps.data.orgName }}
            </span>

      </template>
    </Column>
    <Column
        v-if="expandSidebarDialog"
        :header="_t('label_active')"
        :hidden="!handleCheckRow('active')"
        :style="columnStyle('active')"
        field="active"
    >
      <template #body="slotProps">
            <span
                :style="`${page === 'rule' ? 'padding-left: 0px;' : 'padding-left: 5px'}`"
                style="word-break: break-all;"
            >
              {{ slotProps.data.active ? _t('label_yes') : _t('label_no') }}
            </span>

      </template>
    </Column>
  </DataTable>
</template>

<script>
import { normalizeAlarmPointIcon } from '@/views/alarm_point/utils/alarmPointDto'
import { BRAND_FEATURES, getBrandContext, isBrandFeatureEnabled } from '@/config/brand'
import { getAlarmPointColumnStyle, isAlarmPointOptionEnabled } from './alarmPointTableLayout'

const INSEL_ALARM_POINT_PAGE_SIZES = [10, 20, 50, 100, 200]

export default {
  name: 'AlarmPointTable',
  props: {
    alarmPoints: {
      type: Array,
      default: () => [],
    },
    alarmPointValues: {
      type: Array,
      default: () => [],
    },
    tableDataKey: {
      type: null,
      default: null,
    },
    computedTab: {
      type: String,
      default: 'name'
    },
    apCurrentPage: {
      type: Number,
      default: 0,
    },
    apTotalRecords: {
      type: Number,
      default: 0,
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    alarmPointRows: {
      type: Number,
      default: 100,
    },
    expandSidebarDialog: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    getAlarmPoints: {
      type: Function,
      default: () => {},
    },
    getAlarmPoint: {
      type: Function,
      default: () => {},
    },
    setApCurrentPage: {
      type: Function,
      default: () => {},
    },
    page: {
      type: String,
      default: '',
    },
  },
  emits: ['update:selectedAlarmPointItem', 'update:loading', 'update:apCurrentPage', 'setApCurrentPage', 'setAlarmPointRows'],
  data() {
    return {
      selectedAlarmPointItem: null,
      selectedTab: ''
    }
  },
  methods: {
    selectTablePage(item) {
      // this.loading = true
      this.$emit('update:loading', true)
      this.$emit('setApCurrentPage', item.page)
      if (Number.isFinite(item.rows) && item.rows > 0 && item.rows !== this.alarmPointRows) {
        this.$emit('setAlarmPointRows', item.rows)
      }
      this.getAlarmPoints();
    },
    selectAlarmPoint(data) {
      if (this.page !== 'rule') {
        this.$router.push({
          params: {
            id: data.id
          }
        });
        if (!data || !data.id) {
          return
        }
      } else {
        this.$router.push({path: `/alarm-points/${data.id}?`})
      }
    },
    handleCheckRow(name) {
      return isAlarmPointOptionEnabled(this.alarmPointValues, name)
    },
    normalizeIcon(icon) {
      return normalizeAlarmPointIcon(icon)
    },
    columnStyle(column) {
      return getAlarmPointColumnStyle(column, this.alarmPointValues.length, {
        layout: getBrandContext().activeBrand,
        rulePage: this.page === 'rule',
      })
    },
  },
  computed: {
    alarmPointPageSizeOptions() {
      return isBrandFeatureEnabled(BRAND_FEATURES.INSEL_ALARM_DEFINITION)
        ? INSEL_ALARM_POINT_PAGE_SIZES
        : []
    },
    paginatorTemplate() {
      const navigation = 'FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink'
      return this.alarmPointPageSizeOptions.length ? `RowsPerPageDropdown ${navigation}` : navigation
    },
  },
}

</script>

<style lang="scss" scoped>
::v-deep(.p-datatable) {
  .p-datatable-header {
    padding: 10px;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 10px;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
    padding: 10px;
    background-color: #f8f9fa;
    padding-left: 10px !important;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
    padding: 5px;
    font-weight: 1500;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}


</style>
